import { components } from "@api/schema";

type IApiPaymentMethodProvider =
  components["schemas"]["setupConfig"]["provider"];

export interface IPaymentProviderForMethod {
  credit_card: Extract<IApiPaymentMethodProvider, "stripe">;
  bancontact: Extract<IApiPaymentMethodProvider, "stripe">;
  bank_transfer: Extract<IApiPaymentMethodProvider, "company_operations">;
  credits: Extract<IApiPaymentMethodProvider, "company_operations">;
  paypal?: Extract<IApiPaymentMethodProvider, "stripe">;
}

export type IPaymentMethodProvider<T extends IPaymentMethod> =
  IPaymentProviderForMethod[T];

export type IPaymentMethod =
  components["schemas"]["setupConfig"]["paymentMethod"];

export enum PaymentMethodType {
  CREDIT_CARD = "credit_card",
  BANCONTACT = "bancontact",
  BANK_TRANSFER = "bank_transfer",
  CREDITS = "credits",
  PAYPAL = "paypal"
}

export type IPaymentMethodName = keyof typeof PaymentMethodType;

export type PaymentMethodProviderCombination<T extends IPaymentMethod> = {
  provider: IPaymentMethodProvider<T>;
  paymentMethod: T;
};

export type ICardNetwork =
  | "visa"
  | "mastercard"
  | "bancontact"
  | "americanExpress"
  | "cartesBancaires"
  | "paypal";

export type ISetupConfig = components["schemas"]["setupConfig"];

export type IUserPaymentMethods = components["schemas"]["userPaymentMethods"];
export type IUserPaymentMethod = components["schemas"]["userPaymentMethod"];
